import { React } from 'react'
import Logo from "../../Reutilizables/Logo"
import Menu from "../../Reutilizables/Menu"
import Footer from "../../Reutilizables/Footer"
import Redes from "../../Reutilizables/Redes"
import "../../../styles/login/loginSolo.css"

import firebaseApp from "../../firebase/Credenciales"
import {getAuth, signInWithEmailAndPassword} from "firebase/auth"
const auth = getAuth(firebaseApp)

function LoginSolo() {

	const submitHandler = (e) => {
		e.preventDefault()
	
		const email = e.target.elements.email.value
		const password = e.target.elements.password.value
	
		console.log("submit", email, password);
		signInWithEmailAndPassword(auth, email, password)
		
		setTimeout(() => {
			window.location.href = "/";
		}, 2000); 

	  }

  return (
    <div className='container-main-solo'>
      <div className='container-logo-menu-login-solo'> 
    	<Logo />
        <Menu />
      </div>
	  <Redes />
      <div className="main-solo">
            <div className="login-solo">
				<form onSubmit={submitHandler}>
					<div className='label-login-solo' aria-hidden="true">Mi cuenta</div>
					<input className='input-login-solo' id='email' type="email" autoComplete='email' name="email" placeholder="Correo" required/>
					<input className='input-login-solo' id='password' type="password" autoComplete='off' name="pswd" placeholder="Contraseña" required/>
					<button className='button-login-solo'>Acceder</button>
				</form>
			</div>
	    </div>
		<section className='login-info1'>
			Estás accediendo a la sección solo para usuarios registrados. Ingresa con tu <span>Correo</span> y <span>Contraseña</span>
		</section>
		<section className='login-info2'>
			<div> 
				¿No se ha registrado aún? 
			</div> 
				Descubra los beneficios al   
			<a href="https://www.mercadopago.com.co/subscriptions/checkout?preapproval_plan_id=2c9380848a3be091018a4207899e0406" 
               target='blank'> suscribirse </a> 
			a
			<a href="/ventajas" target="blank"> Tributos y Finanzas.</a>
		</section>
		<Footer />
    </div>
  )
}

export default LoginSolo